<template>
  <div class="betslip__content">
    <div class="betslip--header">
      <span class="league">{{ logs.match_game.league }}</span>
      <span class="match-type">{{ logs.match_game.match_type }}</span>
      <div class="date">
        <span class="date-label">Play Date: </span>
        <span>{{ logs.match_game.play_date | date }}</span>
      </div>
    </div>
    <div class="betslip--con">
      <div
        :class="['-home', {'-selected': logs.betArea === '1'}]"
      >
        <span class="team">
          {{ logs.match_game.home_team }}
        </span>
        <span class="odds">
          {{ logs.match_game['1_val_odd'] }}
        </span>
      </div>

      <div
        :class="['-tie', {'-selected': logs.betArea === 'x'}]"
      >
        <span class="odds">
          {{ logs.match_game.x_val_odd }}
        </span>
      </div>

      <div
        :class="['-away', {'-selected': logs.betArea === '2'}]"
      >
        <span class="team">
          {{ logs.match_game.away_team }}
        </span>
        <span class="odds">
          {{ logs.match_game['2_val_odd'] }}
        </span>
      </div>

      <div class="-score-label">
        <span class="label">(미적중)</span>
      </div>
      <div class="-score-value">
        <span class="home-score">
          {{ logs.match_game.home_score }}
        </span>
        <span class="colon">:</span>
        <span class="away-score">
          {{ logs.match_game.away_score }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    logs: {}
  }
}
</script>
